module.exports = __webpack_public_path__ + "static/media/22.1b12450c.jpg";